// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { SummaryDocumentType } from "../schema";

export function serialize_SummaryDocumentType_internal(value: SummaryDocumentType): unknown {
  return ((value: "ABSTRACT" | "REVIEW"): unknown => {
    return value;
  })(value);
}
export function serialize_SummaryDocumentType(obj: SummaryDocumentType): string {
  return renderJsonWithNumbersAsBigint(serialize_SummaryDocumentType_internal(obj));
}
export function deserialize_SummaryDocumentType_internal(value: unknown): ParserResult<SummaryDocumentType> {
  return ((value: unknown): ParserResult<"ABSTRACT" | "REVIEW"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/SummaryDocumentType]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "ABSTRACT":
        return { success: true, value: "ABSTRACT" };
      case "REVIEW":
        return { success: true, value: "REVIEW" };
      default:
        return { success: false, reason: `[#/components/schemas/SummaryDocumentType]: '${value}' expected to be enum, one of 'ABSTRACT, REVIEW'.` };
    }
  })(value);
}
export function deserialize_SummaryDocumentType(str: string): ParserResult<SummaryDocumentType> {
  return deserialize_SummaryDocumentType_internal(parseJsonWithNumbersAsBigint(str));
}
